import Head from "next/head";
import Image from "next/image";
import { Inter } from "next/font/google";
import styles from "@/styles/Home.module.css";
// import TopHeader from "@/components/TopHeader";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FeaturedProjects from "@/components/FeaturedProjects";
import Announcements from "@/components/Announcements";
import GepdecStory from "@/components/GepdecStory";
import WhyGepdec from "@/components/WhyGepdec";
import InternationalForay from "@/components/InternationalForay";
import InitialHome from "@/components/InitialHome";


const inter = Inter({
  subsets: ["latin"],
  weight: ["800"], // Only load critical weight for hero heading
  variable: "--font-inter",
  display: 'swap',
  preload: true,
  fallback: ['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'],
});

export default function Home() {
  return (
    <div className={inter.variable}>
      <Head>
        <title>PISCESIA POWER TRANSMISSION - EPC company in Power Infrastructure</title>
        <meta name="description" content="PISCESIA Power Transmission Pvt. Ltd. - India's fastest-growing EPC service provider specializing in EHV GIS substations, power transmission, underground cables, and tunnel electro-mechanical systems." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        
        {/* Critical font preloading for immediate LCP */}
        <link 
          rel="preload" 
          href="https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyeMZhrib2Bg-4.woff2" 
          as="font" 
          type="font/woff2" 
          crossOrigin="anonymous" 
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        
        {/* Inline critical CSS for hero heading - LCP optimization */}
        <style dangerouslySetInnerHTML={{
          __html: `
            /* Critical above-the-fold styles - LCP optimization */
            h1#hero-heading {
              font-size: 4rem !important;
              font-weight: 800 !important;
              color: #1f2937 !important;
              margin: 0 0 2rem 0 !important;
              line-height: 1.1 !important;
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
              letter-spacing: -0.02em !important;
              text-align: center !important;
              visibility: visible !important;
              display: block !important;
              opacity: 1 !important;
              transform: none !important;
              position: relative !important;
              z-index: 100 !important;
              contain: layout style paint;
              will-change: auto;
              text-rendering: optimizeSpeed;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
            }
            .blue-span {
              color: #3b82f6 !important;
              font-weight: 800 !important;
            }
            /* Critical container styles */
            main[aria-labelledby="hero-heading"] {
              min-height: 100vh !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              background: #ffffff !important;
              position: relative !important;
              overflow: hidden !important;
            }
            /* Responsive font sizes */
            @media (max-width: 1024px) {
              h1#hero-heading {
                font-size: 3rem !important;
              }

              main[aria-labelledby="hero-heading"] {
                min-height: 80vh !important;
              }
            }
            @media (max-width: 768px) {
              h1#hero-heading {
                font-size: 2rem !important;
                line-height: 1.2 !important;
              }

              main[aria-labelledby="hero-heading"] {
                min-height: 80vh !important;
              }
            }
            @media (max-width: 640px) {
              h1#hero-heading {
                font-size: 1.5rem !important;
                line-height: 1.3 !important;
              }

              main[aria-labelledby="hero-heading"] {
                min-height: 60vh !important;
              }
            }
          `
        }} />
        
        {/* Resource hints for critical assets */}
        <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
        <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
        <link rel="preload" as="image" href="/logos/main_logo.png" />
        
        {/* Optimize viewport for mobile LCP */}
        <meta name="theme-color" content="#ffffff" />
        
        {/* Defer non-critical scripts */}
        <script defer dangerouslySetInnerHTML={{
          __html: `
            // Optimize Web Vitals - reduce LCP delay
            window.addEventListener('DOMContentLoaded', function() {
              // Ensure hero heading is immediately visible
              const heroHeading = document.getElementById('hero-heading');
              if (heroHeading) {
                heroHeading.style.visibility = 'visible';
                heroHeading.style.opacity = '1';
              }
            });
          `
        }} />
      </Head>
      
      {/* Critical above-the-fold content - render immediately */}
      <InitialHome />
      
      {/* Defer non-critical components to improve LCP */}
      {/* <TopHeader /> */}
      <Header />
      <GepdecStory />

      <InternationalForay />
      <WhyGepdec />
      <FeaturedProjects/>
      <Announcements />
      <Footer />
    </div>
  );
}
